import { render, staticRenderFns } from "./EditTaskBadge.vue?vue&type=template&id=f2afbab4"
import script from "./EditTaskBadge.vue?vue&type=script&lang=js"
export * from "./EditTaskBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports